// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path='../index.d.ts'/>
import React from "react"
import { Provider } from "react-redux"
import ClientData from "@/common/client_data"
import { setEnabledFlags } from "@/signomatic/app/flags"
import Sign from "@/signomatic/app/sign"
import SignomaticRouter from "@/signomatic/components/router"
import { SignContext } from "@/signomatic/contexts"
import createStore from "@/signomatic/store"
import { type Fontdata } from "@/signomatic/util/fonts"
import "@/signomatic/styles/index.css"

function keyHandler(e: KeyboardEvent) {
  const addBtn = document.getElementById("add_to_cart")
  const updateBtn = document.getElementById("update_sign")

  if (e.key === "F8") {
    if (addBtn) {
      addBtn.click()
    } else if (updateBtn) {
      updateBtn.click()
    }

    return false
  }

  return true
}

document.addEventListener("DOMContentLoaded", () => {
  document.getElementById("signomatic")?.addEventListener("keydown", keyHandler)
})

if (window.location.search.indexOf("clear=true") > 0) {
  localStorage.clear()
}

const sign = new Sign()

const store = createStore({
  signs: ClientData.signs,
  editing: ClientData.editing,
})

sign.connectStore(store)

const Signomatic: React.FC<{ orderId: string; adminId: string; fontdata: Fontdata; featureFlags: string[] }> = ({
  orderId,
  adminId,
  fontdata,
  featureFlags,
}) => {
  setEnabledFlags(featureFlags)

  return (
    <Provider store={store}>
      <SignContext.Provider value={sign}>
        <SignomaticRouter orderId={orderId} adminId={adminId} fontdata={fontdata} />
      </SignContext.Provider>
    </Provider>
  )
}

export default Signomatic
